'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _variants = require('../modules/variants');

var _variants2 = _interopRequireDefault(_variants);

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('template-cart', {
  onLoad: function onLoad() {
    // Product variant switching
    var products = {};
    var selectors = {
      addToCart: '[data-add-to-cart-button]',
      addToCartText: '[data-add-to-cart-text]',
      addToCartError: '[data-add-to-cart-text]',
      addToCartErrorText: '[data-add-to-cart-text] p',
      quantitySelects: '[data-quantity]',
      cartProducts: '[data-cart-item-with-variants]',
      giftProducts: '[data-gift-item-with-variants]',
      originalSelectorId: '[data-product-select]',
      productJson: '[data-product-json]',
      singleOptionSelector: '[data-single-option-selector]'
    };

    var initVariants = function initVariants() {
      var cartProducts = document.querySelectorAll(selectors.cartProducts);

      cartProducts.forEach(function (product, index) {
        if (!product.classList.contains('variants-initialised')) {
          var id = product.dataset.collectionProduct;
          var jason = JSON.parse(product.querySelector(selectors.productJson).innerHTML);
          console.log(jason);
          var $container = (0, _jquery2.default)(product);
          var options = {
            $container: $container,
            enableHistoryState: false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: jason
          };

          product.classList.add('variants-initialised');

          products[id] = {
            json: jason,
            variants: new _variants2.default(options),
            container: $container

            // Variant change event
          };$container.on('variantChange', function (event) {
            updateProductVariant(event, $container);
          });

          // Quantity select change events
          (0, _jquery2.default)(selectors.quantitySelects, $container).on('change', function (event) {
            if ((0, _jquery2.default)(this).is(':checked')) {
              var line = $container.data('cart-item');
              (0, _jquery2.default)($container).addClass('is-removing');
              AjaxCart.updateItemByLine(line, (0, _jquery2.default)(this).val());
            }
          });
        }
      });

      showRelatedItems();
    };

    var initGiftVariants = function initGiftVariants() {
      var cartProducts = document.querySelectorAll(selectors.giftProducts);

      cartProducts.forEach(function (product, index) {
        if (!product.classList.contains('variants-initialised')) {
          var id = product.dataset.collectionProduct;
          var jason = JSON.parse(product.querySelector(selectors.productJson).innerHTML);
          var $container = (0, _jquery2.default)(product);
          var options = {
            $container: $container,
            enableHistoryState: false,
            singleOptionSelector: selectors.singleOptionSelector,
            originalSelectorId: selectors.originalSelectorId,
            product: jason
          };

          product.classList.add('variants-initialised');

          products[id] = {
            json: jason,
            variants: new _variants2.default(options),
            container: $container

            // Variant change event
          };$container.on('variantChange', function (event) {
            updateGiftVariant(event, $container);
          });
        }
      });
    };

    /**
     * Updates the gift popup with the new variant ID, or shows a "sold out" message if the variant is not available
     */
    var updateGiftVariant = function updateGiftVariant(event, $container) {
      var original_variant = (0, _jquery2.default)(event.target).find(selectors.originalSelectorId).data('original-variant');
      var variant = event.variant;

      if (variant !== null) {
        (0, _jquery2.default)(selectors.addToCart, $container).attr('data-quick-add', variant.id);

        if (variant.available) {
          (0, _jquery2.default)(selectors.addToCart, $container).prop('disabled', false);
          (0, _jquery2.default)(selectors.addToCartText, $container).html(theme.strings.addToCart);
        } else {
          (0, _jquery2.default)(selectors.addToCart, $container).prop('disabled', true);
          (0, _jquery2.default)(selectors.addToCartText, $container).html(theme.strings.soldOut);
        }
      } else {
        (0, _jquery2.default)(selectors.addToCart, $container).attr('data-quick-add', '').prop('disabled', true);
      }
    };

    /**
     * Updates the cart with the new variant ID, or shows a "sold out" message if the variant is not available
     */
    var updateProductVariant = function updateProductVariant(event, $container) {
      var original_variant = (0, _jquery2.default)(event.target).find(selectors.originalSelectorId).data('original-variant');
      var variant = event.variant;
      var line = (0, _jquery2.default)(event.target).data('cart-item');

      if (variant !== null) {
        if (variant.available) {
          (0, _jquery2.default)(selectors.cartProducts, $container).addClass('is-removing');
          (0, _jquery2.default)(selectors.addToCartError, $container).addClass('hide');
          (0, _jquery2.default)(selectors.addToCartErrorText, $container).html('');

          // Update the cart item
          if (variant.id != original_variant) {
            AjaxCart.switchVariants(line, variant.id);
          }
        } else {
          (0, _jquery2.default)(selectors.addToCartError, $container).removeClass('hide');
          (0, _jquery2.default)(selectors.addToCartErrorText, $container).html(theme.strings.variant);
          (0, _jquery2.default)(selectors.addToCartErrorText, $container).html(theme.strings.variant);
        }
      } else {
        // Do something when there is no such variant
      }
    };

    // Remove items once they're moved to the wishlist
    (0, _jquery2.default)(document).on('click', '.wishlist-remove-from-cart', function (event) {
      event.preventDefault();
      (0, _jquery2.default)(this).siblings('button.wk-add-product').trigger('click');
      AjaxCart.removeItemByLine((0, _jquery2.default)(this).data('cart-remove'));
    });

    // Slick related products
    var showRelatedItems = function () {
      var collection = (0, _jquery2.default)(this.container).find('[data-featured-collection]');
      var limit = (0, _jquery2.default)(collection).data('collection-products');
      var limit_medium = (0, _jquery2.default)(collection).data('collection-products-medium');
      var limit_small = (0, _jquery2.default)(collection).data('collection-products-small');

      var settings = (0, _slick2.default)({
        slidesToShow: limit,
        slidesToScroll: limit,
        appendArrows: (0, _jquery2.default)(this.container).find('.slick-arrows'),
        arrows: true,
        responsive: [{
          breakpoint: Breakpoints['large'],
          settings: {
            slidesToShow: limit_medium,
            slidesToScroll: limit_medium
          }
        }, {
          breakpoint: Breakpoints['small'],
          settings: {
            slidesToShow: limit_small,
            slidesToScroll: limit_small
          }
        }]
      });

      collection.slick(settings);

      var trigger = new Event('lazy:reload');
      document.dispatchEvent(trigger);
    }.bind(this);

    document.addEventListener('cart:rendered', initVariants);
    initVariants();
    initGiftVariants();
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});